<template>
  <div class="row mt-5 mt-md-7 animate -sequence">
    <div
      class="col-6 offset-md-3 col-md-5 anim-el"
      data-anim-order="2"
      data-anim-type="slide-right"
    >
      <div class="image-container -rect_image" id="advisory-1"></div>
    </div>
    <div
      class="col-6 col-md-3 anim-el"
      data-anim-order="1"
      data-anim-type="slide-right"
    >
      <div class="image-container -rect_image" id="advisory-2"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#advisory-1 {
  background-image: url(../assets/advisory-1.jpg);
}
#advisory-2 {
  background-image: url(../assets/advisory-2.jpg);
}
</style>
